import React from 'react'
import ListaPropietariosBloquear from '../../../components/ListaPropietariosBloquear'
import styled from 'styled-components'
import Boton from '../../../components/Boton'
import Titulo2 from '../../../components/Titulo2'
import { fondo } from '../../../components/UI/variables'

const StyledSection = styled.section`
  background-color: ${fondo};
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const StyledHeader = styled.header`
  display: flex;
  justify-content: space-between;
  height: 40px;
  width: 100%;
  align-items: center;
`
const TituloStyled= styled(Titulo2)`
  width: 100%;
  text-align: center;
`
const StyledDiv = styled.div`
  padding-top: 32px;
  width: 100%;
`
const BloquearPropietarios = () => {
  return (
    <StyledSection>
      <StyledHeader>
        <Boton to={`/HomeAdmin`}>Atras</Boton>
        <TituloStyled $naranja> Bloqueo de Propietarios</TituloStyled>
      </StyledHeader>
      <StyledDiv>
        <ListaPropietariosBloquear/>
      </StyledDiv>
    </StyledSection>
  )
}

export default BloquearPropietarios